import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';

import { dotFormatter, formatDate, roundNumber, setTranslationValues } from '../../../../../../helpers';
import { useStore, useTranslation } from '../../../../../../hooks';
import { T } from '../../../../../../constants';

import progressBarPopupImg1 from '../../../../../../assets/images/free-drop/progress-bar-img1.png';
import progressBarPopupImg2 from '../../../../../../assets/images/free-drop/progress-bar-img2.png';
import progressBarPopupImg3 from '../../../../../../assets/images/free-drop/progress-bar-img3.png';
import progressBarPopupImg4 from '../../../../../../assets/images/free-drop/progress-bar-img4.png';
import progressBarPopupImg5 from '../../../../../../assets/images/free-drop/progress-bar-img5.png';
import progressBarPopupImg6 from '../../../../../../assets/images/free-drop/progress-bar-img6.png';

interface FreeDropRulesProps {
  minGoal: number;
}

export const FreeDropRules: React.FC<FreeDropRulesProps> = observer(({ minGoal }) => {

    const { freeDropStore, gameStore } = useStore();
    const { currencySymbol, precision } = gameStore;
    const { freeDropInfo, sortedDropsByDate, themeConfig } = freeDropStore;

  const t = useTranslation();

  const rulesContent = useMemo(() => {
    const startDate = new Date(sortedDropsByDate[0].dropDate);
    const endDate = new Date(sortedDropsByDate[sortedDropsByDate.length - 1].dropDate);
    const accumulationMinOdd = freeDropInfo?.accumulationMinOdd;
    const content = setTranslationValues(t(T.RICH_FREE_DROP_RULES_DESC), {
      startDate: formatDate(startDate),
      endDate: formatDate(endDate),
      level1TurnoverAmount: `${dotFormatter(roundNumber(minGoal, precision))}${currencySymbol}`,
      claimLimitPerDrop: freeDropInfo?.claimLimitPerDrop || 1,
      accumulationMinOdd: accumulationMinOdd ? setTranslationValues(t(T.FREE_DROP_ACCULATION_MIN_ODD), { minOdd: `x${accumulationMinOdd}` }) : '',
    })
    return { __html: content };
  }, [minGoal, precision, freeDropInfo, sortedDropsByDate, currencySymbol, t]);

  return (
    <div className="free-drop-popup-info-content">

      <div className="free-drop-popup-info-content-row">
        <p className="free-drop-popup-info-content-row-title">{t(T.PREGRESS_BAR)}</p>
        <p className="free-drop-popup-info-content-row-subtitle">
          {t(T.FREE_DROP_PREGRESS_BAR_DESC)}
        </p>
        <div className="free-drop-popup-progress-bar-block">
          <div className="free-drop-popup-progress-bar-img-wrp">
            <img className="free-drop-popup-progress-bar-img" src={progressBarPopupImg1} alt="progress 0" />
          </div>
          <div className="free-drop-popup-progress-bar-img-wrp">
            <img className="free-drop-popup-progress-bar-img" src={progressBarPopupImg2} alt="progress 1" />
          </div>
          <div className="free-drop-popup-progress-bar-img-wrp">
            <img className="free-drop-popup-progress-bar-img" src={progressBarPopupImg3} alt="progress 2" />
          </div>
          <div className="free-drop-popup-progress-bar-img-wrp">
            <img className="free-drop-popup-progress-bar-img" src={progressBarPopupImg4} alt="progress 3" />
          </div>
          <div className="free-drop-popup-progress-bar-img-wrp">
            <img className="free-drop-popup-progress-bar-img" src={progressBarPopupImg5} alt="progress active" />
          </div>
        </div>
      </div>

      <div className="free-drop-popup-info-content-row">
        <p className="free-drop-popup-info-content-row-title">{t(T.TIMER)}</p>
        <p className="free-drop-popup-info-content-row-subtitle">
          {t(T.FREE_DROP_TIMER_DESC)}
        </p>
        <div className="free-drop-popup-info-time-block">
          <img className="free-drop-popup-info-time-img" src={progressBarPopupImg6} alt="" />
          <span className="free-drop-popup-info-time-info">0:41</span>
        </div>
      </div>

      <div className="free-drop-popup-info-content-row">
        <p className="free-drop-popup-info-content-row-title">{t(T.REWARD)}</p>
        <p className="free-drop-popup-info-content-row-subtitle">
          {t(T.FREE_DROP_REWARD_DESC)}
        </p>
        <div className="free-drop-popup-prize-wrp">
          <div className="free-drop-popup-prize-img-block">
            <img src={themeConfig.rewardIcon} alt="" className="free-drop-popup-prize-img" />
          </div>
          <div className="free-drop-popup-prize-amount-block">
            <span className="free-drop-popup-prize-amount">50$</span>
            <span className="free-drop-popup-prize-amount-id">ID: 123456</span>
          </div>
        </div>
      </div>

      <div className="free-drop-popup-info-content-row">
        <p className="free-drop-popup-info-content-row-title">{t(T.FREE_DROP_RULES)}</p>
        <p
          dangerouslySetInnerHTML={rulesContent}
          className="free-drop-popup-info-content-row-subtitle"
        />
      </div>

    </div>
  );
});
